import React from "react";
import LoginService from "./LoginService";
import { NavLink } from "react-router-dom";
import { API_BASEURLICON } from "../../Config";

const Login = () => {
  const {
    handleChangeOTP,
    inputOtp,
    generateOtp,
    validationOTPErrors,
    logInWithOtp,
    isOtpGenerated,
    otpValue,
    setOtpValue,
  } = LoginService();

  const imageUrl = API_BASEURLICON;

  return (
    <>
      <div className="cus-wrapper">
        <video autoPlay loop playsInline className="background-video">
          <source
            src="https://www.mobikwik.com/assets/images/revampMBK/root_page/homepage-video-final.mp4"
            type="video/mp4"
          />
        </video>
        <div className="video-overlay"></div>

        <div className="wrapper">
          <div className="cus-click-back-page">
            <div className="back-icon-img">
              <img
                src="assets/pwa-static/pwa/images/icons/angle-left.png"
                className="back-icon"
                alt="back icon"
              />
            </div>
            <div className="header-section ">
              <NavLink to="/">Back</NavLink>
            </div>
          </div>

          <div className="title-text">
            <div className="title login cus-login-1">
              <img src={`${imageUrl}Image/Website/1/B2C-logo.png`} alt="logo" />
            </div>
            <div className="title signup cus-login-1">
              <img src={`${imageUrl}Image/Website/1/B2C-logo.png`} alt="logo" />
            </div>
          </div>

          <div className="form-container">
            <div className="loginOtp">
              <label htmlFor="signup">Login With OTP</label>
            </div>

            <div className="form-inner">
              <form className="signup">
                <div className="field">
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    name="UserID"
                    onChange={handleChangeOTP}
                    value={inputOtp?.UserID}
                  />
                  {validationOTPErrors.UserID && (
                    <span className="text-danger-inputfield">
                      {validationOTPErrors.UserID}
                    </span>
                  )}
                </div>

                {isOtpGenerated && (
                  <div className="field">
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={otpValue}
                      onChange={(e) => setOtpValue(e.target.value)}
                    />
                  </div>
                )}

                <div className="field btn">
                  <div className="btn-layer"></div>

                  {!isOtpGenerated ? (
                    <button type="button" onClick={generateOtp}>
                      Get OTP
                    </button>
                  ) : (
                    <button type="button" onClick={logInWithOtp}>
                      Login with OTP
                    </button>
                  )}
                </div>

                <div className="cus-register-section">
                  <div className="pass-link">
                    <NavLink to="/signup">Register Now</NavLink>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;


//........ THIS FLOW CAN BE USED IN FUTURE SO DONT DELETE IT, FOR OTHER REPLICA PROJECT THIS MIGHT BE USED.........//

// import React, { useState } from "react";
// import LoginService from "./LoginService";
// import { NavLink } from "react-router-dom";
// import { API_BASEURLICON } from "../../Config";

// const Login = () => {
//   const {
//     input,
//     handleChange,
//     handleSubmit,
//     showPassword,
//     togglePassword,
//     validationErrors,
//     handleChangeOTP,
//     inputOtp,
//     generateOtp,
//     validationOTPErrors,
//     logInWithOtp,
//     isOtpGenerated,
//     otpValue,
//     isOtpRequired,
//     setOtpValue,
//   } = LoginService();
//   const [isEmailLogin, setIsEmailLogin] = useState(true);
//   const imageUrl = API_BASEURLICON;
//   return (
//     <>
//       <div className="cus-wrapper">
//         <video autoplay="" loop="" playsinline="" class="background-video">
//           <source
//             src="https://www.mobikwik.com/assets/images/revampMBK/root_page/homepage-video-final.mp4"
//             type="video/mp4"
//           />
//         </video>
//         <div class="video-overlay"></div>

//         <div className="wrapper">
//           <div className="cus-click-back-page">
//             <div className="back-icon-img">
//               <img
//                 src="assets/pwa-static/pwa/images/icons/angle-left.png"
//                 className="back-icon"
//                 alt="back icon"
//               />
//             </div>
//             <div className="header-section ">
//               <NavLink to="/">Back</NavLink>
//             </div>
//           </div>
//           <div className="title-text">
//             <div className="title login cus-login-1">
//               <img src={`${imageUrl}Image/Website/1/B2C-logo.png`} alt="logo" />
//             </div>
//             <div className="title signup cus-login-1">
//               <img src={`${imageUrl}Image/Website/1/B2C-logo.png`} alt="logo" />
//             </div>
//           </div>
//           <div className="form-container">
//             <div className="slide-controls">
//               <input type="radio" name="slide" id="login" defaultChecked />
//               <input type="radio" name="slide" id="signup" />
//               <label
//                 htmlFor="login"
//                 className={`slide login ${isEmailLogin ? "active" : ""}`}
//                 onClick={() => setIsEmailLogin(true)}
//               >
//                 Login With UserId
//               </label>
//               <label
//                 htmlFor="signup"
//                 className={`slide signup ${!isEmailLogin ? "active" : ""}`}
//                 onClick={() => setIsEmailLogin(false)}
//               >
//                 Login With OTP
//               </label>
//               <div className="slider-tab"></div>
//             </div>
//             <div className="form-inner">
//               {isEmailLogin && (
//                 <>
//                   <form className="login">
//                     <div className="field">
//                       <input
//                         type="text"
//                         placeholder="Enter the Id"
//                         name="UserID"
//                         value={input?.UserID}
//                         onChange={handleChange}
//                       />
//                       {validationErrors.UserID && (
//                         <span className="text-danger-inputfield">
//                           {validationErrors.UserID}
//                         </span>
//                       )}
//                     </div>

//                     <div className="field" style={{ position: "relative" }}>
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         placeholder="Enter the Password"
//                         name="Password"
//                         value={input?.Password}
//                         onChange={handleChange}
//                       />
//                       <span
//                         onClick={togglePassword}
//                         style={{
//                           position: "absolute",
//                           right: "30px",
//                           top: "50%",
//                           transform: "translateY(-50%)",
//                           cursor: "pointer",
//                           color: "#333",
//                         }}
//                       >
//                         {showPassword ? "🙈" : "👁️"}
//                       </span>
//                       {validationErrors.Password && (
//                         <span className="text-danger-inputfield">
//                           {validationErrors.Password}
//                         </span>
//                       )}
//                     </div>
//                     {isOtpRequired && (
//                       <div className="field">
//                         <input
//                           type="text"
//                           placeholder="Enter OTP"
//                           name="otp"
//                           value={input?.otp}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     )}

//                     <div className="field btn">
//                       <div className="btn-layer"></div>
//                       <button type="button" onClick={handleSubmit}>
//                         Submit
//                       </button>
//                     </div>

//                     <div className="cus-register-section">
//                       <div className="pass-link">
//                         <NavLink to="/forgetpassword">Forgot password?</NavLink>
//                       </div>
//                     </div>
//                     <div className="signup-link">
//                       Not a member? <NavLink to="/signup">Signup now</NavLink>
//                     </div>
//                   </form>
//                 </>
//               )}

//               {!isEmailLogin && (
//                 <form className="signup">
//                   <div className="field">
//                     <input
//                       type="text"
//                       placeholder="Mobile Number"
//                       name="UserID"
//                       onChange={handleChangeOTP}
//                       value={inputOtp?.UserID}
//                     />
//                     {validationOTPErrors.UserID && (
//                       <span className="text-danger-inputfield">
//                         {validationOTPErrors.UserID}
//                       </span>
//                     )}
//                   </div>

//                   {isOtpGenerated && (
//                     <div className="field">
//                       <input
//                         type="text"
//                         placeholder="Enter OTP"
//                         value={otpValue}
//                         onChange={(e) => setOtpValue(e.target.value)}
//                       />
//                     </div>
//                   )}

//                   <div className="field btn">
//                     <div className="btn-layer"></div>
//                     {!isOtpGenerated ? (
//                       <button type="button" onClick={generateOtp}>
//                         Get OTP
//                       </button>
//                     ) : (
//                       <button type="button" onClick={logInWithOtp}>
//                         Login with OTP
//                       </button>
//                     )}
//                   </div>

//                   <div className="cus-register-section">
//                     <div className="pass-link">
//                       <NavLink to="/signup">Register Now</NavLink>
//                     </div>
//                     <div className="pass-link">
//                       <NavLink to="/forgetpassword">Forgot password?</NavLink>
//                     </div>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;

